<section class="how-to-buy" id="how-to-buy">
  <div class="container">
    <h2 class="section-title mx-auto text-center mb-4">
      {{ 'how-to-buy.title' | translate }}
    </h2>

    <!-- Desktop view -->
    <div class="wrapper d-none d-sm-block">
      <div class="row">
        @for (box of boxes; track box) {
          <div class="col-12 col-lg-3">
            <div class="box">
              <p class="title m-0">{{ box.title | translate }}</p>
              <p class="desc m-0">{{ box.desc | translate }}</p>
            </div>
          </div>
        }
      </div>
    </div>

    <!-- Mobile view with buttons -->
    <div class="wrapper-mobile d-block d-sm-none position-relative">
      <div class="mobile-slider d-flex overflow-auto" #slider>
        @for (box of boxes; track box) {
          <div class="box me-3 flex-shrink-0">
            <p class="title m-0">{{ box.title | translate }}</p>
            <p class="desc m-0">{{ box.desc | translate }}</p>
          </div>
        }
      </div>

      <!--Next And Previous Button-->

      <div class="d-flex align-items-center justify-content-center">
        <button class="scroll-btn left" (click)="scrollLeft()"><img src="/assets/images/webp/slide-left.webp" loading="lazy" alt="slide-left" /></button>
        <button class="scroll-btn right" (click)="scrollRight()"><img src="/assets/images/webp/slide-right.webp" loading="lazy" alt="slide-right" /></button>
      </div>
    </div>
  </div>
</section>
